import _export from '../internals/export.js';
import getBuiltIn$1 from '../internals/get-built-in.js';
import anObject$1 from '../internals/an-object.js';
import freezing from '../internals/freezing.js';

var $ = _export;
var getBuiltIn = getBuiltIn$1;
var anObject = anObject$1;
var FREEZING = freezing; // `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions

$({
  target: 'Reflect',
  stat: true,
  sham: !FREEZING
}, {
  preventExtensions: function preventExtensions(target) {
    anObject(target);

    try {
      var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
      if (objectPreventExtensions) objectPreventExtensions(target);
      return true;
    } catch (error) {
      return false;
    }
  }
});
